import Page from './index';

export default { path: '/home/tenant/tenantUserAdmin', component: Page };
